<div class="contents-area">
  <div class="element-column">
    <div class="column-list">
      <label class="list-input-title">企画回</label>
      <div class="list-input-content">
        <app-catalog-text-with-order #txti_CatalogId [autofocus]="true" [required]="true" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="kymw4500Model.catalogId" width="7rem"
          (onChangedOrderCode)="kymw4500Model.orderCode = $event"
          (ngModelChange)="eventBlurHandler_CatalogId()">
        </app-catalog-text-with-order>
      </div>
      <label class="list-input-title">受注コード</label>
      <div class="list-input-content">
        <app-order-text-with-catalog #txti_OrderCode [autofocus]="true" [required]="true" [tabindex]="0"
          [forcedEnabledMode]="'true'" [(ngModel)]="kymw4500Model.orderCode" width="7rem"
          (onChangedCatalogId)="this.kymw4500Model.catalogId = $event"
          (ngModelChange)="eventBlurHandler_OrderCode()">
        </app-order-text-with-catalog>
      </div>
      <label class="list-input-title">媒体</label>
      <div class="list-input-content">
        <app-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'" [tabindex]="0"
          [width]="280" [(ngModel)]="kymw4500Model.mediumType" (change)="eventBlurHandler_MediumType()">
        </app-medium-type-combo-box>
      </div>
    </div>

    <div class="layout_balance">
      <button id="btn_Display" #btn_Display class="btn-secondary" [tabindex]="0"
        (click)="eventClickHandler_Display()">表示</button>
      <button id="btn_SpecialFeatureCopy" class='btn-secondary' [disabled]="kymw4500Model.specialFeatureCopyBtnDisabled"
        (click)="eventClickHandler_SpecialFeatureCopy()">特集コピー</button>
    </div>
  </div>
  <div class="element-column">
    <wj-flex-grid #dtg_SpecialFeature [itemsSource]="kymw4500Model.featureList" id="dtg_SpecialFeature"
      [headersVisibility]="'Column'" [frozenColumns]="2" [isReadOnly]="true"
      [allowSorting]="false" [allowDragging]="'None'" [tabindex]="0" [selectionMode] = "'Row'">
      <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'FeatureCode'" [header]="'特集コード'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="200" [binding]="'MediumName'" [header]="'媒体'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'DelivCatalogId'" [header]="'企画回'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="200" [binding]="'FeatureName'" [header]="'特集名'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" class="text-label-required" [(ngModel)]="cell.item.FeatureName" [style.width.%]="100" [required]="true" plessInputTextSub [maxlength]="30"
            [disabled]="cell.item.PlannerSelectionFlag === '1' || kymw4500Model.isOnlyCatalogId || !isEditable" restrict="[ -￮]"
            (blur)="eventChangeHandler_FeatureName(cell)" (focus)="eventChangingHandler_FeatureName(cell)" [fullOnly]="true" />
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'ApprovalFlowType'" [header]="'承認フロー区分'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <select class="text-label-required" [(ngModel)]="cell.item.ApprovalFlowType" [style.width.%]="'100'" [required]="true"
            [disabled]="cell.item.PlannerSelectionFlag === '1' || !isEditable">
            <ng-template ngFor let-item [ngForOf]="this.kymw4500Model.approvalFlowTypeList">
              <option value="{{item.approvalFlowType}}">{{item.approvalFlowTypeName}}</option>
            </ng-template>
          </select>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'NotificationUserId'" [header]="'通知受領担当者'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <select [(ngModel)]="cell.item.NotificationUserId" [style.width.%]="'100'"
            [disabled]="cell.item.PlannerSelectionFlag === '1' || !isEditable">
            <option value=""></option>
            <ng-template ngFor let-item [ngForOf]="this.kymw4500Model.notificationUserList">
              <option value="{{item.notificationUserId}}">{{item.notificationUserId}}:{{item.notificationUserName}}</option>
            </ng-template>
          </select>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'Tags'" [header]="'タグ情報'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="150" [binding]="'PayeeSuppliers'" [header]="'取引先'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="150" [binding]="'AssociatedCompanyName'" [header]="'企画支援'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="362" [binding]="'Remarks'" [header]="'備考'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" [(ngModel)]="cell.item.Remarks" [style.width.%]="100" plessInputTextSub restrict="[ -￮]" [maxlength]="256"
            [disabled]="cell.item.PlannerSelectionFlag === '1' || kymw4500Model.isOnlyCatalogId || !isEditable" [fullOnly]="true" />
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
    <button id="btn_Add" #btn_Add class="btn-secondary" [tabindex]="0"
      (click)="eventClickHandler_Add()" [disabled]="!isEditable || isMaxCount || kymw4500Model.addBtnDisabled">追加</button>
  </div>

  <footer class="footer-buttons">
    <button id="btn_PageEdit" #btn_PageEdit class="btn-secondary" (click)="eventClickHandler_OpenPageEdit()" 
    [tabindex]="0">ページ・台割編集</button>
    <button id="btn_FixedSpecialFeatureList" class="btn-secondary" (click)="eventClickHandler_FixedSpecialFeatureList()"
    [tabindex]="0">固定特集一覧表示</button>
    <button id="btn_Save" #btn_Save class="btn-primary" (click)="eventClickHandler_Save()" [tabindex]="0" [disabled]="!isEditable || kymw4500Model.saveBtnDisabled">
    保存</button>
  </footer>